module.exports = "<div class=\"form-group\">\r\n    <div class=\"col-sm-offset-4 col-sm-8\">\r\n        <ng-content></ng-content>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/form/form-group-footer/form-group-footer.component.html
// module id = ./src/app/shared/components/form/form-group-footer/form-group-footer.component.html
// module chunks = main